import { apiFetch, apiFetchJson } from "@/utils/apiFetch";

const BASE_API_URL = import.meta.env.VITE_API_URL;

export const alertsService = {
  getAlerts: async (id: string): Promise<any> => {
    return apiFetchJson<any>(`${BASE_API_URL}/insights/${id}/alerts/`);
  },
  getAlertDetail: async (id: string, alertId: string): Promise<any> => {
    return apiFetchJson<any>(
      `${BASE_API_URL}/insights/${id}/alerts/${alertId}/`,
    );
  },
  getAlertHistory: async (id: string, alertId: string): Promise<any> => {
    return apiFetchJson<any>(
      `${BASE_API_URL}/insights/${id}/alerts/${alertId}/history/`,
    );
  },
  createAlert: async (id: string, payload: any): Promise<any> => {
    return apiFetchJson<any>(`${BASE_API_URL}/insights/${id}/alerts/`, {
      method: "POST",
      body: JSON.stringify(payload),
    });
  },
  validateAlertRule: async (id: string, payload: any): Promise<any> => {
    return apiFetchJson<any>(
      `${BASE_API_URL}/insights/${id}/alerts/validate/`,
      { method: "POST", body: JSON.stringify(payload) },
    );
  },
  evaluateAlert: async (id: string, payload: any): Promise<any> => {
    return apiFetchJson<any>(
      `${BASE_API_URL}/insights/${id}/alerts/evaluate/`,
      { method: "POST", body: JSON.stringify(payload) },
    );
  },
  deleteAlert: async (id: string, alertId: string): Promise<any> => {
    const response = await apiFetch(
      `${BASE_API_URL}/insights/${id}/alerts/${alertId}/`,
      { method: "DELETE" },
    );
    // 204 No Content response has no body, so don't try to parse JSON
    return response.status === 204 ? null : response.json();
  },
  updateAlert: async (
    id: string,
    alertId: string,
    payload: any,
  ): Promise<any> => {
    return apiFetchJson<any>(
      `${BASE_API_URL}/insights/${id}/alerts/${alertId}/`,
      { method: "PATCH", body: JSON.stringify(payload) },
    );
  },
};
